/* eslint-disable react/jsx-no-undef */
import { withTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import {
  useNotification,
  getErrorNotification,
} from '@components/Notification';

import ContentWrapper from '@components/ContentWrapper/ContentWrapper';
import BasicButton from '@components/BasicButton';
import LegalNotes from '@core/login/components/LegalNotes';
import { useMytaverse } from '@providers/MytaverseProvider';
import { ILoginPageView } from './interfaces';
import { classes } from './styles';
import PageWrapper from '@components/PageWrapper';

const LoginPageView = ({ title, t: translate }: ILoginPageView) => {
  const { loginError, signIn } = useMytaverse();
  const { showNotification } = useNotification();

  if (loginError) {
    showNotification(
      getErrorNotification({
        message: loginError,
      }),
    );
  }

  const BottomElement = (
    <Box sx={classes.bottom}>
      <Box sx={classes.button}>
        <BasicButton onClick={signIn} primary dataTestId="login-start-button">
          {translate('login.start')}
        </BasicButton>
      </Box>
      <Box sx={classes.legalNotes}>
        <LegalNotes />
      </Box>
    </Box>
  );

  return (
    <PageWrapper bottomElement={BottomElement} title={title}>
      <ContentWrapper
        subtitle={translate('login.subtitle')}
        forceKeepSubtitle
      ></ContentWrapper>
    </PageWrapper>
  );
};

export default withTranslation()(LoginPageView);
